import { Alert, AlertTitle, Button } from "@mui/material"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next";

type PorpsType = {
    alert?: Date | null,
    openReport: () => void,
    branchName?: string,
}
export default function ShowAlert({ alert, openReport, branchName }: PorpsType) {
    const { t } = useTranslation();
    if (alert === undefined) {
        return
    }
    const date = dayjs(alert)
    const duration = date.diff(dayjs());
    if (alert === null) {
        return <Alert onClose={() => {}} className="w-full" severity="success">
            <AlertTitle>{t('do_not_check_before')}</AlertTitle>
        </Alert>
    }
    const color = duration / (1000 * 86400) < -3 ? 'info' : 'warning'
    console.log(branchName)
    return (
        <Alert className="items-center" severity={color} action={<Button onClick={openReport} variant="contained" color={color}>{t('see_report')}</Button>}>
            <AlertTitle>{t('checked_in', { date: dayjs.duration(date.diff(dayjs())).locale('fa').humanize(true), branchName })}</AlertTitle>
            {
                alert && alert.toLocaleDateString('fa-IR')
            }
        </Alert>
    )
}
